export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_15-26cccff409f9c2dffefa14fb9c3d05fd.jpg";